// Owns the editable iframe mechanics. The MLT controller only needs to provide
// a frame and receive the updated Description HTML.
export default class DescriptionEditor {
  constructor({ onChange }) {
    this.onChange = onChange
    this.body = null
  }

  start(frame) {
    const body = frame.contentDocument?.body
    if (!body) return false

    this.stop()
    this.body = body
    body.setAttribute("contenteditable", "true")
    body.setAttribute("spellcheck", "true")
    body.dataset.mltEditing = "true"
    body.addEventListener("input", this.captureInput)
    body.addEventListener("paste", this.pastePlainText)
    body.addEventListener("drop", this.preventRichDrop)
    body.focus()
    return true
  }

  stop() {
    if (!this.body) return

    this.body.removeAttribute("contenteditable")
    this.body.removeAttribute("spellcheck")
    delete this.body.dataset.mltEditing
    this.body.removeEventListener("input", this.captureInput)
    this.body.removeEventListener("paste", this.pastePlainText)
    this.body.removeEventListener("drop", this.preventRichDrop)
    this.body = null
  }

  captureInput = (event) => this.onChange(event.currentTarget.innerHTML)

  pastePlainText = (event) => {
    event.preventDefault()
    const text = event.clipboardData?.getData("text/plain") || ""
    event.currentTarget.ownerDocument.execCommand("insertText", false, text)
  }

  preventRichDrop = (event) => event.preventDefault()
}
